<geaui-snackbar-v3 />

<!-- Access denied: no token is available. -->
<app-no-access *ngIf="hasAccess === false"></app-no-access>

<!-- Checking access. -->
<div class="app-loading" *ngIf="hasAccess === null" role="status" aria-label="loading">
  <geaui-progress-spinner />
</div>

<!-- Main application. The external login pages only use the content area. -->
<geaui-page-layout-v3 *ngIf="hasAccess === true" [headerTemplate]="externalAccessPage() ? emptyHeader : header"
  [contentTemplate]="content" [sidebarTemplate]="externalAccessPage() ? null : sidebar">
  <ng-template #emptyHeader></ng-template>
  <ng-template #header>
    <app-header></app-header>
    <app-mobile-navigation></app-mobile-navigation>
  </ng-template>
  <ng-template #content>
    <div class="spinner" *ngIf="!externalAccessPage() && ((spinnerService.loading$ | async) || !tokensReady())"
      role="status" aria-label="loading">
      <geaui-progress-spinner />
    </div>

    <div class="content-body">
      <router-outlet *ngIf="tokensReady()"></router-outlet>

    </div>
  </ng-template>
  <ng-template #sidebar>

    <!-- Replace this with the preferred icon. -->
    <geaui-sidebar-v3 [navigationItems]="navItems" [slimView]="true" [adminViewNavigationItems]="adminNavItems"
      [devisionIconPath]="'/assets/icons/IOTest.svg'" [bottomNavigation]="botItems" [devisionName]="title"
      devisionIconBackgroundColor="var(--geaui-night-blue)">
    </geaui-sidebar-v3>

  </ng-template>
</geaui-page-layout-v3>